
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { ModalContainer } from "../components/ModalContainer";
// import DocViewer from "react-doc-viewer";
// import { Document, Page } from 'react-pdf';

const video = "https://api.ethicsglobal.com/ethicsglobal.com/api/serve-attachment/ATP05I85Yx5V09NPR68Z62623z26102yw6/?token=AQICAHgqhC4DGw9CxCzmOwOp2N4k71e3UZce9FxtQQeM4AA6AQHw4ZLRYzzcYt%2FZ95ZUaCaCAAAAbzBtBgkqhkiG9w0BBwagYDBeAgEAMFkGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMpfyzINx4StJLtX%2FDAgEQgCxvWdv%2FHy7ibso1U5gdbxm4AbANQ9iqQBYyPxXmeAFdfJ3xH5vto0Hyq0PYtQ%3D%3D";
const pdf = "https://api.ethicsglobal.com/ethicsglobal.com/api/serve-attachment/AT20I65L6L6262068Bhq24Q2bJ6l552jT1/?token=AQICAHgqhC4DGw9CxCzmOwOp2N4k71e3UZce9FxtQQeM4AA6AQHw4ZLRYzzcYt%2FZ95ZUaCaCAAAAbzBtBgkqhkiG9w0BBwagYDBeAgEAMFkGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMpfyzINx4StJLtX%2FDAgEQgCxvWdv%2FHy7ibso1U5gdbxm4AbANQ9iqQBYyPxXmeAFdfJ3xH5vto0Hyq0PYtQ%3D%3D";
const imagen = "https://api.ethicsglobal.com/ethicsglobal.com/api/serve-attachment/ATWB68619vi0S06225L6K26W52TE05B80J/?token=AQICAHgqhC4DGw9CxCzmOwOp2N4k71e3UZce9FxtQQeM4AA6AQHw4ZLRYzzcYt%2FZ95ZUaCaCAAAAbzBtBgkqhkiG9w0BBwagYDBeAgEAMFkGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMpfyzINx4StJLtX%2FDAgEQgCxvWdv%2FHy7ibso1U5gdbxm4AbANQ9iqQBYyPxXmeAFdfJ3xH5vto0Hyq0PYtQ%3D%3D";

export const ModalHelp = ({ show = false, onHide, type = "" }) => {
  
  const [t] = useTranslation("components");

  return (
    <ModalContainer
      show={show}
      onHide={onHide}
      size="xl"
    >
      <Typography fontSize={28} fontWeight={700} color="primary.main" >
        {t("Sobre esta sección")}
      </Typography>
      <hr className="hr-div" style={{ marginBottom: "16px 0" }} />
      {
        type === "evaluation" &&
        <FileViewer url={imagen} type="image" />
      }
      {
        type === "scenarios" &&
        <FileViewer url={video} type="video" />
      }
      {
        type === "involved" &&
        <FileViewer url={pdf} type="pdf" />
      }
      {
        type === "" &&
        <FileViewer url={imagen} type="image" />
      }
    </ModalContainer>
  );
};

const FileViewer = ({ url, type }) => {
  
  if (type === "image") {
    return (
      <img src={url} alt="image" style={{ width: '100%', borderRadius: 8 }} />
    );
  }

  if (type === "video") {
    return (
      <video controls style={{ width: '100%', borderRadius: 8 }}>
        <source src={url} />
      </video>
    );
  }

  if (type === "pdf") {
    return (
      <Box sx={{ overflow: 'hidden', width: '100%' }}>
        <iframe
          src={url}
          style={{ width: '100%', aspectRatio: '16/11', border: 'none'}}
        />
      </Box>
    );
  }
  return <></>;
};
